import { connect } from "dva";
import { createForm } from "rc-form";
import { RequestForms } from "./RequestForms";
import { routerRedux } from "dva/router";

import { storagePrivilege } from "../../utils/constant";

const fetchActionURL = "config/fetchAllRequestForms";
const fetchUsersURL = "users/getAllUsers";

 const mapStateToProps = (state, ownProps) => {
  const { loading, config, authentication } = state;
  const { requestFormsList, requestFormsTotal, deleteRequestModal, changeRequestModal } = config;
  const isLoading = loading.effects[fetchActionURL];
  const isUsersLoading = loading.effects[fetchUsersURL];

  const { accessList, profile } = authentication;

  return {
    isLoading,
    isUsersLoading,
    contentList: requestFormsList,
    contentTotal: requestFormsTotal,
    fetchActionURL,
    accessList,
    deleteRequestModal,
    changeRequestModal,
    profile
  };
};

 const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    redirect(pathname) {
      dispatch(routerRedux.push({ pathname: `${pathname}` }));
    },
    getList(data) {
      dispatch({ type: fetchActionURL, payload: data });
    },
    openDeleteModal(){
      dispatch({ type: "config/save", payload: { deleteRequestModal: true } });
    },
    openChangeModal(){
      dispatch({ type: "config/save", payload: { changeRequestModal: true } });
    },
    getSingleForm(data){
      dispatch({ type: "config/getSingleForm", payload: data });
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(createForm()(RequestForms));

